import {AbstractControl, ValidationErrors, Validators} from "@angular/forms";

export function validatePassword(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) {
    return null;
  }

  const hasUpperCase = /[A-Z]+/.test(value);
  const hasLowerCase = /[a-z]+/.test(value);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]+/.test(value);

  const valid = hasUpperCase && hasLowerCase && hasSpecialChar;
  return valid ? null : { passwordStrength: true };
}




export function numbersOnlyPattern(): string {
  return "^[0-9]*$"
}

export function urlPattern(): string {
  // return "^(https?:\\/\\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\\/\\w \\.-]*)*\\/?$" // Causes browser to hang.
  // return "^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$"
  return "^(https?:\\/\\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([+\\/\\w \\.-@]*)*\\/?$" // Existing. Was workign but doesn't accept @ character as needed in some social media links.
  // return "^(?:http|https):\\/\\/[\\w.-]+(?:\\.[\\w\\.-]+)*[\\w\\-\\._~:/?#[\\]@!\\$&'\\(\\)\\*\\+,;=]+$";
}
